/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

 import type { LexicalEditor} from 'lexical';

 import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import { useMemo } from 'react';
 
 export function OnStartPlugin({onStart}: {onStart?: ( editor: LexicalEditor) => void}): null {

   const [editor] = useLexicalComposerContext();
    useMemo(() => {
        if (onStart) {
          onStart(editor)
        }
    }, [onStart, editor])

   return null;
 }